var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconJoinUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#45812b",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(3.55556,3.55556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,9c-5.238,0 -9.5,4.486 -9.5,10c0,5.514 4.262,10 9.5,10c5.238,0 9.5,-4.486 9.5,-10c0,-5.514 -4.262,-10 -9.5,-10zM44.5,9c-5.238,0 -9.5,4.486 -9.5,10c0,5.514 4.262,10 9.5,10c5.238,0 9.5,-4.486 9.5,-10c0,-5.514 -4.262,-10 -9.5,-10zM23.5,31c-7.012,0 -13.25987,3.28414 -15.92187,8.36914c-1.978,3.779 1.20823,7.63086 4.99023,7.63086h13.27734c-3.958,-5.143 -1.34434,-11.04172 3.72266,-15.13672c-1.902,-0.559 -3.94936,-0.86328 -6.06836,-0.86328zM44.6875,31.00391c-6.981,-0.168 -13.33523,2.97024 -16.11523,7.99023c-2.062,3.724 0.63873,7.91586 4.42773,8.00586c1.084,0.026 4.67383,0 4.67383,0c3.457,-9.257 14.62867,-12.82173 22.63867,-7.42773c-0.031,-0.061 -0.0627,-0.12164 -0.0957,-0.18164c-2.644,-4.946 -8.6833,-8.22172 -15.5293,-8.38672zM51.74609,41.0625c-6.058,0 -10.96775,4.91075 -10.96875,10.96875c0,6.058 4.91075,10.96875 10.96875,10.96875c6.058,0 10.96875,-4.91075 10.96875,-10.96875c0,-6.058 -4.91075,-10.96875 -10.96875,-10.96875zM51.74609,45.40625c1.104,0 2,0.896 2,2v2.625h2.625c1.104,0 2,0.896 2,2c0,1.104 -0.896,2 -2,2h-2.625v2.625c0,1.104 -0.896,2 -2,2c-1.104,0 -2,-0.896 -2,-2v-2.625h-2.625c-1.104,0 -2,-0.896 -2,-2c0,-1.104 0.896,-2 2,-2h2.625v-2.625c0,-1.104 0.896,-2 2,-2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJoinUs);
export default __webpack_public_path__ + "static/media/icon-join-us.a91fc2a1d816fe83932bb131d22fce00.svg";
export { ForwardRef as ReactComponent };